<template>
  <div class="beefCont">
    <img src="../assets/imgs/100/bg.jpg" class="bg" alt="" />
    <Qrcode :pic="100" :bottom="'1.7rem'" />
    <div class="phoneCommon">
        咨询电话：<a href="tel:028-87705569" style="color:#fff">028-87705569</a>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/assets/public.scss";
.beefCont {
  width: 100vw;
  position: relative;
  .bg {
    width: 100%;
    height: 82.15rem;
    display: block;
  }
}
</style>